import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialogdeleteaccountwithactualsconfirm',
    templateUrl: './dialogdeleteaccountwithactualsconfirm.component.html',
    styleUrls: ['./dialogdeleteaccountwithactualsconfirm.component.css'],
    standalone: false
})
export class DialogDeleteAccountWithActualsConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
